<div [hidden]="droppedDown">
  <section name="photo-general" [class.side-by-side]="sideBySide">
    <ng-container
      *ngTemplateOutlet="photoActions; context: { selectedPhoto: photoOnFocus }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="photoHolder; context: { selectedPhoto: photoOnFocus }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="photoComment; context: { selectedPhoto: photoOnFocus }"
    ></ng-container>

    <div
      class="photo-carousel"
      *ngIf="photos.length > 1 && photoOnFocus != null && fixedIndex == null"
    >
      <div class="photo-carousel-horizon">
        <div class="vertical-flex-center">
          <button (click)="moveCarouselImage(-1)" mat-mini-fab>
            <mat-icon class="icon-up">chevron_left</mat-icon>
          </button>
        </div>
        <div class="carousel-image-holder">
          <div *ngFor="let img of getPhotos()">
            <div class="vertical-flex-center">
              <img
                (click)="selectCarouselImage(img)"
                [ngClass]="{
                  hidden: !checkCarouselPosition(img.index),
                  'selected-image': img.index == photoOnFocus.index,
                  'red-bottom-border': img.data.state == uploadStates.failed,
                  'orange-bottom-border':
                    !img.data.url || img.data.state == uploadStates.ongoing,
                  'placeholder-img': !img.data.url
                }"
                class="carousel-image"
                [src]="
                  img.data.url
                    ? transform(img.data.url)
                    : 'assets/img_ph_landscape.svg'
                "
              />
            </div>
          </div>
        </div>
        <div class="vertical-flex-center">
          <button (click)="moveCarouselImage(1)" mat-mini-fab>
            <mat-icon class="icon-up">chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
<div [hidden]="!droppedDown">
  <section name="photo-general-dropped" *ngFor="let photo of photos">
    <ng-container
      *ngTemplateOutlet="photoActions; context: { selectedPhoto: photo }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="photoHolder; context: { selectedPhoto: photo }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="photoCommentDropped; context: { selectedPhoto: photo }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="buttonsDropped; context: { selectedPhoto: photo }"
    ></ng-container>
  </section>
</div>

<div class="hidden full-screen-overlay" #cameraLayer>
  <app-camera #camera></app-camera>
</div>
<div *ngIf="selectedImage" class="full-screen-overlay viewer">
  <app-slider
    (closeSlider)="closeSlider($event)"
    [selectedImage]="selectedImage"
    [currentImage]="photoOnFocus"
    [sliderPhotos]="photos"
    [title]="componentDescriptionTitle"
    [limit]="limit"
  >
  </app-slider>
</div>

<!-- TEMPLATES -->

<ng-template #photoActions let-photo="selectedPhoto">
  <div class="photo-actions">
    <button
      class="main-action-button"
      [class.greyed]="disableSinglePhotoActions()"
      mat-stroked-button
      (click)="viewPhoto(photo)"
    >
      <mat-icon class="material-icons-outlined">zoom_in</mat-icon>
      <div i18n="@@general.photo-remarks.enlarge">enlarge</div>
    </button>
    <button
      class="main-action-button"
      *ngIf="showMultiPhotoActions(true)"
      mat-stroked-button
      color="secundary"
      [class]="!canChangePosition(false, photo) ? 'greyed' : null"
      (click)="changePhotoIndex(false, photo)"
    >
      <mat-icon>move_up</mat-icon>
      <div i18n="@@general.photo-remarks.move-up">move up</div>
    </button>

    <button
      class="main-action-button"
      *ngIf="showMultiPhotoActions(true)"
      mat-stroked-button
      [class]="!canChangePosition(true, photo) ? 'greyed' : null"
      (click)="changePhotoIndex(true, photo)"
    >
      <mat-icon>move_down</mat-icon>
      <div i18n="@@general.photo-remarks.move-down">move down</div>
    </button>

    <button
      class="main-action-button"
      *ngIf="isAuthCanWrite"
      [class.greyed]="disableSinglePhotoActions()"
      mat-stroked-button
      (click)="deleteSelectedPhoto(photo)"
    >
      <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
      <div i18n="@@general.photo-remarks.delete">delete</div>
    </button>
    <button
      class="main-action-button"
      *ngIf="showMultiPhotoActions(true)"
      [class]="photos.length < 1 ? 'greyed' : null"
      mat-stroked-button
      (click)="deletePhotos()"
    >
      <mat-icon class="material-icons-outlined">delete_sweep</mat-icon>
      <div i18n="@@general.photo-remarks.delete-more">delete more</div>
    </button>

    <!-- TODO: ngcontainer with ngif + ngcontainer with ngswitch -->
    <ng-container *ngIf="photos.length > 0">
      <ng-container [ngSwitch]="photo?.data?.state">
        <button
          *ngSwitchCase="uploadStates.done"
          class="upload-gen"
          mat-button
          disabled
        >
          <mat-icon class="upload-gen upload-done">download_done</mat-icon>
          <div class="upload-done" i18n="@@general.photo-remarks.upload-done">
            uploaded
          </div>
        </button>
        <button
          *ngSwitchCase="uploadStates.ongoing"
          class="upload-gen"
          mat-button
          disabled
        >
          <mat-icon
            style="transform: rotate(-180deg)"
            class="upload-gen upload-ongoing"
            >downloading</mat-icon
          >
          <div
            class="upload-ongoing"
            i18n="@@general.photo-remarks.upload-ongoing"
          >
            upload ongoing
          </div>
        </button>
        <button
          *ngSwitchCase="uploadStates.failed"
          class="upload-gen"
          mat-button
          disabled
        >
          <mat-icon class="upload-gen upload-failed">sync_problem</mat-icon>
          <div
            class="upload-failed"
            i18n="@@general.photo-remarks.upload-failed"
          >
            upload failed
          </div>
        </button>
        <div *ngSwitchDefault></div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #uploading>
  <div class="photo-container width100">
    <div class="photo-holder-image photo-placeholder">
      <mat-icon>wallpaper</mat-icon>
    </div>
    <!-- <img class="photo-holder-image svg-ph" src="assets/img_ph_landscape.svg" /> -->
  </div>
</ng-template>

<ng-template #photoHolder let-photo="selectedPhoto">
  <div class="photo-holder" *ngIf="photos?.length && photo">
    <mat-chip-list class="position-container-right">
      <mat-chip disabled>max. {{ limit }}</mat-chip>
    </mat-chip-list>
    <mat-chip-list class="position-container-center" *ngIf="limit > 1">
      <mat-chip disabled>{{ photo.index + 1 }}/{{ photos.length }}</mat-chip>
    </mat-chip-list>
    <mat-chip-list
      *ngIf="componentDescriptionTitle != null"
      class="position-container-left"
    >
      <mat-chip disabled>{{ componentDescriptionTitle }}</mat-chip>
    </mat-chip-list>
    <div
      class="photo-container vertical-flex-center"
      *ngIf="photo?.data?.url; else uploading"
    >
      <div
        *ngIf="photo?.data?.state == uploadStates.failed"
        class="reupload-bar"
        (click)="reupload(photo)"
      >
        <span i18n="@@survey.photo.uploadfailed"
          >Upload failed. Click here to retry</span
        >

        <mat-icon class="upload-failed">sync_problem</mat-icon>
      </div>
      <img
        (click)="editPhoto(photo)"
        class="photo-holder-image"
        [src]="transform(photo.data.url)"
      />
    </div>
  </div>
  <div class="photo-holder" *ngIf="!photos?.length || !photo">
    <mat-chip-list class="position-container-right">
      <mat-chip disabled>max. {{ limit }}</mat-chip>
    </mat-chip-list>
    <mat-chip-list
      *ngIf="componentDescriptionTitle != null"
      class="position-container-left"
    >
      <mat-chip disabled>{{ componentDescriptionTitle }}</mat-chip>
    </mat-chip-list>
    <div class="photo-container width100">
      <div class="photo-holder-image photo-placeholder">
        <mat-icon>wallpaper</mat-icon>
      </div>
      <!-- <img
        class="photo-holder-image svg-ph"
        src="assets/img_ph_landscape.svg"
      /> -->
    </div>
  </div>
</ng-template>

<ng-template #photoComment let-photo="selectedPhoto">
  <div class="photo-comment">
    <div class="photo-comment-actions">
      <button mat-stroked-button (click)="showCamera(photo?.index ?? 0)" [class.disabled]="!this.isAuthCanWrite">
        <mat-icon class="material-icons-outlined">camera_alt</mat-icon>
        <div i18n="@@general.photo-remarks.camera">camera</div>
      </button>

      <input
        type="file"
        id="{{ identifier }}-gallery"
        accept="image/*"
        (change)="addGalleryImage($event, photo?.index ?? 0)"
        [class.disabled]="!isAuthCanWrite"
        [multiple]="
          fixedIndex == undefined && limit > 1 && photos.length < limit - 1
        "
        #galleryInput
        class="hidden"
      />
      <button
        mat-stroked-button
        (click)="galleryInput.click()"
        (click)="registerGalleryClick()" [class.disabled]="!this.isAuthCanWrite"
      >
        <mat-icon class="material-icons-outlined">perm_media</mat-icon>
        <div i18n="@@general.photo-remarks.gallery">gallery</div>
      </button>

      <button
        *ngIf="showMultiPhotoActions()"
        mat-stroked-button
        (click)="toggleDropDown(photo)"
      >
        <mat-icon
          >keyboard_double_arrow_{{ droppedDown ? "up" : "down" }}</mat-icon
        >
        <div
          *ngIf="droppedDown; else seeMore"
          i18n="@@general.photo-remarks.see-less"
        >
          see less
        </div>
      </button>
    </div>
    <textarea
      cdkTextareaAutosize
      class="photo-comment-text"
      name="remarks"
      [placeholder]="this.isAuthCanWrite ? 'add a comment...' : ''"
      [hidden]="disableSinglePhotoActions()"
      [ngModel]="photo != null ? photo[remarkFieldFEName] : null"
      (ngModelChange)="onRemarkChanged(photo, $event)"
      [readonly]="!this.isAuthCanWrite"
    >
    </textarea>
  </div>
</ng-template>

<ng-template #photoCommentDropped let-photo="selectedPhoto">
  <div class="photo-comment-dropped">
    <textarea
      cdkTextareaAutosize
      class="photo-comment-text-dropped"
      name="remarks"
      [placeholder]="this.isAuthCanWrite ? 'add a comment...' : ''"
      [hidden]="photos?.length < 1"
      [ngModel]="photo != null ? photo[remarkFieldFEName] : null"
      (ngModelChange)="onRemarkChanged(photo, $event)"
      [readonly]="!this.isAuthCanWrite"
    >
    </textarea>
  </div>
</ng-template>

<ng-template #buttonsDropped let-photo="selectedPhoto">
  <div class="btns-dropped">
    <div class="horizon-line"></div>
    <div class="photo-comment-actions">
      <button mat-stroked-button (click)="showCamera(photo?.index ?? 0)" [class.disabled]="!isAuthCanWrite">
        <mat-icon class="material-icons-outlined">camera_alt</mat-icon>
        <div i18n="@@general.photo-remarks.camera">camera</div>
      </button>

      <input
        type="file"
        id="{{ identifier }}-{{ photo?.index }}-gallery"
        accept="image/*"
        (change)="addGalleryImage($event, photo?.index ?? 0)"
        [class.disabled]="!isAuthCanWrite"
        [multiple]="photos.length < limit - 1"
        #galleryInputDropped
        class="hidden"
      />
      <button
        mat-stroked-button
        (click)="galleryInputDropped.click()"
        (click)="registerGalleryClick()"
        [class.disabled]="!isAuthCanWrite"
      >
        <mat-icon class="material-icons-outlined">perm_media</mat-icon>
        <div i18n="@@general.photo-remarks.gallery">gallery</div>
      </button>

      <button
        *ngIf="showMultiPhotoActions()"
        mat-stroked-button
        (click)="toggleDropDown(photo)"
      >
        <mat-icon
          >keyboard_double_arrow_{{ droppedDown ? "up" : "down" }}</mat-icon
        >
        <div
          *ngIf="droppedDown; else seeMore"
          i18n="@@general.photo-remarks.see-less"
        >
          see less
        </div>
      </button>
    </div>
    <div class="horizon-line"></div>
  </div>
</ng-template>

<ng-template #seeMore>
  <div i18n="@@general.photo-remarks.see-all">see all</div>
</ng-template>
